// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".active-class[data-v-5a7492d4]{background-color:hsla(0,0%,84.3%,.5)}", ""]);
// Exports
module.exports = exports;
